import get from 'lodash/get';
import { Coordinate } from 'modules/types/common';
import Config from 'react-native-config';
import { ID_TYPE_CORPPROV } from 'store/findProvider/constants';
import * as myDocSelectors from 'store/myDoctors/selectors';
import * as profileSelectors from 'store/profile/selectors';
import * as accountSelectors from 'store/account/selectors';
import * as geoLocationSelectors from 'store/geolocation/selectors';
import * as StorageUtility from 'storage/recentSearches/storage';
import { mapInsuranceIdsToReqDto } from 'store/findProvider/mappers';
import { slcGeoCoords } from 'store/geolocation/constants';
import { Thunk } from '../types';
import * as selectors from './selectors';
import * as types from './types';

export const PROVIDER_SEARCH = 'FIND_PROVIDER.PROVIDER_SEARCH';
export const PROVIDER_SEARCH_SUCCESS = 'FIND_PROVIDER.PROVIDER_SEARCH_SUCCESS';
export const PROVIDER_SEARCH_FAIL = 'FIND_PROVIDER.PROVIDER_SEARCH_FAIL';
export const PROVIDER_SEARCH_RESET_RESULTS = 'FIND_PROVIDER.PROVIDER_SEARCH_RESET_RESULTS';

export const PROVIDER_SEARCH_MORE = 'FIND_PROVIDER.PROVIDER_SEARCH_MORE';
export const PROVIDER_SEARCH_MORE_SUCCESS = 'FIND_PROVIDER.PROVIDER_SEARCH_MORE_SUCCESS';
export const PROVIDER_SEARCH_MORE_FAIL = 'FIND_PROVIDER.PROVIDER_SEARCH_MORE_FAIL';

export const PROVIDER_GET_DETAILS = 'FIND_PROVIDER.PROVIDER_GET_DETAILS';
export const PROVIDER_GET_DETAILS_SUCCESS = 'FIND_PROVIDER.PROVIDER_GET_DETAILS_SUCCESS';
export const PROVIDER_GET_DETAILS_FAIL = 'FIND_PROVIDER.PROVIDER_GET_DETAILS_FAIL';
export const PROVIDER_RESET_DETAIL = 'FIND_PROVIDER.PROVIDER_RESET_DETAIL';

export const PROVIDER_GET_COMMENTS = 'FIND_PROVIDER.PROVIDER_GET_COMMENTS';
export const PROVIDER_GET_COMMENTS_SUCCESS = 'FIND_PROVIDER.PROVIDER_GET_COMMENTS_SUCCESS';
export const PROVIDER_GET_COMMENTS_FAIL = 'FIND_PROVIDER.PROVIDER_GET_COMMENTS_FAIL';
export const PROVIDER_RESET_COMMENTS = 'FIND_PROVIDER.PROVIDER_RESET_COMMENTS';

export const PROVIDER_SET_HAS_ACTIVE_FILTERS = 'FIND_PROVIDER.PROVIDER_SET_HAS_ACTIVE_FILTERS';
export const SET_INITIAL_PROVIDER_SEARCH_FILTER =
  'FIND_PROVIDER.SET_INITIAL_PROVIDER_SEARCH_FILTER';
export const RESET_TEMPORARY_PROVIDER_SEARCH_FILTER =
  'FIND_PROVIDER.RESET_TEMPORARY_PROVIDER_SEARCH_FILTER';
export const SET_TEMPORARY_PROVIDER_SEARCH_FILTER =
  'FIND_PROVIDER.SET_TEMPORARY_PROVIDER_SEARCH_FILTER';
export const SET_ACTIVE_PROVIDER_SEARCH_FILTER = 'FIND_PROVIDER.SET_ACTIVE_PROVIDER_SEARCH_FILTER';
export const PROVIDER_RESET_SEARCH_FILTER = 'FIND_PROVIDER.RESET_SEARCH_FILTER';

export const PROVIDER_SET_SORT_BY = 'FIND_PROVIDER.SET_SORT_BY';
export const PROVIDER_SET_TEXT_NAME = 'FIND_PROVIDER.SET_TEXT_NAME';
export const PROVIDER_SET_TEXT_LOCATION = 'FIND_PROVIDER.SET_TEXT_LOCATION';
export const PROVIDER_SET_GEO_LOCATION = 'FIND_PROVIDER.SET_GEO_LOCATION';

export const PROVIDER_GET_HOSPITALS = 'FIND_PROVIDER.GET_HOSPITALS';
export const PROVIDER_GET_HOSPITALS_SUCCESS = 'FIND_PROVIDER.GET_HOSPITALS_SUCCESS';
export const PROVIDER_GET_HOSPITALS_FAIL = 'FIND_PROVIDER.GET_HOSPITALS_FAIL';

export const PROVIDER_GET_CLINICS = 'FIND_PROVIDER.GET_CLINICS';
export const PROVIDER_GET_CLINICS_SUCCESS = 'FIND_PROVIDER.GET_CLINICS_SUCCESS';
export const PROVIDER_GET_CLINICS_FAIL = 'FIND_PROVIDER.GET_CLINICS_FAIL';

export const PROVIDER_GET_INSURANCES = 'FIND_PROVIDER.GET_INSURANCES';
export const PROVIDER_GET_INSURANCES_SUCCESS = 'FIND_PROVIDER.GET_INSURANCES_SUCCESS';
export const PROVIDER_GET_INSURANCES_FAIL = 'FIND_PROVIDER.GET_INSURANCES_FAIL';

export const PROVIDER_GET_LANGUAGES = 'FIND_PROVIDER.GET_LANGUAGES';
export const PROVIDER_GET_LANGUAGES_SUCCESS = 'FIND_PROVIDER.GET_LANGUAGES_SUCCESS';
export const PROVIDER_GET_LANGUAGES_FAIL = 'FIND_PROVIDER.GET_LANGUAGES_FAIL';

export const PROVIDER_SET_SELECTED_GENDER = 'FIND_PROVIDER.SET_SELECTED_GENDER';

export const PROVIDER_GET_SPECIALTIES = 'FIND_PROVIDER.GET_SPECIALTIES';
export const PROVIDER_GET_SPECIALTIES_SUCCESS = 'FIND_PROVIDER.GET_SPECIALTIES_SUCCESS';
export const PROVIDER_GET_SPECIALTIES_FAIL = 'FIND_PROVIDER.GET_SPECIALTIES_FAIL';

export const PROVIDER_SET_FROM_ROUTE = 'FIND_PROVIDER.PROVIDER_SET_FROM_ROUTE';
export const PROVIDER_CLEAR_FROM_ROUTE = 'FIND_PROVIDER.PROVIDER_CLEAR_FROM_ROUTE';

export const PROVIDER_RESET_ACTION_TC = 'FIND_PROVIDER.PROVIDER_RESET_ACTION_TC';

export const PROVIDER_SET_ACCEPTED_TC = 'FIND_PROVIDER.PROVIDER_SET_ACCEPTED_TC';

export const PROVIDER_GET_SUGGESTIONS = 'FIND_PROVIDER.PROVIDER_GET_SUGGESTIONS';
export const PROVIDER_GET_SUGGESTIONS_SUCCESS = 'FIND_PROVIDER.PROVIDER_GET_SUGGESTIONS_SUCCESS';
export const PROVIDER_GET_SUGGESTIONS_FAIL = 'FIND_PROVIDER.PROVIDER_GET_SUGGESTIONS_FAIL';

const providerSearchBase = (
  type: string,
  config = { pageNumber: 0, pageSize: 10 },
  filterQueryParam?: boolean
): Thunk => (dispatch, getState) => {
  const { pageNumber, pageSize } = config;
  const state = getState();

  const {
    sortBy,
    textName,
    locationText,
    activeFilters,
    geoLocation
  } = selectors.searchFilterSelector(state);

  const geoLocationCoords = geoLocation || geoLocationSelectors.geolocationCoordsSelector(state);

  const insurances = mapInsuranceIdsToReqDto(
    profileSelectors.currentConsumerInsurancesSelector(state)
  );

  const payload: types.ProviderSearchRequest = {
    orderBy: sortBy.value,
    limit: pageSize,
    page: pageNumber
  };

  const pcpIdList = myDocSelectors.currentConsumerPcpIdListSelector(state);
  const preferredIdList = myDocSelectors.currentConsumerPreferredIdListSelector(state);
  const pastIdList = myDocSelectors.currentConsumerPastIdListSelector(state);

  payload.myPCPList = pcpIdList.length > 0 ? pcpIdList : [];
  payload.myPreferredProvidersList = preferredIdList.length > 0 ? preferredIdList : [];
  payload.myPastProvidersList = pastIdList.length > 0 ? pastIdList : [];
  // Send either user overridden location text or coordinates, or if coords are null, use Salt Lake as default
  if (locationText !== '') {
    payload.locationText = locationText;
  } else if (geoLocationCoords?.latitude && geoLocationCoords?.longitude) {
    payload.location = {
      lat: geoLocationCoords.latitude,
      lng: geoLocationCoords.longitude
    };
  } else if (!geoLocationCoords) {
    payload.location = {
      lat: slcGeoCoords.latitude,
      lng: slcGeoCoords.longitude
    };
  }

  if (activeFilters.filters.length) {
    payload.filters = [...activeFilters.filters];
  }
  if (activeFilters.facets.length) payload.facets = [...activeFilters.facets];
  if (insurances.length) payload.userInsuranceAliasValues = [...insurances];

  const currentConsumerId = accountSelectors.currentAccountConsumerIdSelector(state);
  let url = `${Config.PROVIDER_URL_SEARCH}`;
  if (filterQueryParam) url += '?schedulingProviderFilter=true';
  const inputText = textName.trim();

  // only add this to the search params and recent searches if its a non-empty valid string and authenticated user
  // also, be sure this IF is the last thing before the dispatch so the search params are properly stored
  if (inputText) {
    payload.input = inputText;

    if (currentConsumerId) {
      StorageUtility.addSearch(currentConsumerId, inputText, payload);
    }
  }

  dispatch({
    type,
    payload: {
      client: 'azureProviderSearch',
      request: {
        method: 'post',
        url,
        data: {
          ...payload
        }
      }
    }
  });
};

export const providerSearch = (): Thunk => dispatch => {
  const config = {
    pageNumber: 0,
    pageSize: parseInt(Config.PROVIDER_RESULT_PAGE_SIZE, 10)
  };

  dispatch(providerSearchBase(PROVIDER_SEARCH, config));
};

export const providerSearchMore = (): Thunk => (dispatch, getState) => {
  const pageNumber = selectors.providerSearchPageNumberSelector(getState());

  const config = {
    pageNumber: pageNumber + 1,
    pageSize: parseInt(Config.PROVIDER_RESULT_PAGE_SIZE, 10)
  };

  dispatch(providerSearchBase(PROVIDER_SEARCH_MORE, config));
};

/* Temp functions while waiting for data updates to include flag for this data */
export const schedulingProviderSearch = (): Thunk => dispatch => {
  const filterQueryParam = true;
  const config = {
    pageNumber: 0,
    pageSize: 100
  };

  dispatch(providerSearchBase(PROVIDER_SEARCH, config, filterQueryParam));
};

/* Temp functions while waiting for data updates to include flag for this data */
export const schedulingProviderSearchMore = (): Thunk => (dispatch, getState) => {
  const pageNumber = selectors.providerSearchPageNumberSelector(getState());
  const filterQueryParam = true;
  const config = {
    pageNumber: pageNumber + 1,
    pageSize: 100
  };

  dispatch(providerSearchBase(PROVIDER_SEARCH_MORE, config, filterQueryParam));
};

export const resetProviderResults = () => ({
  type: PROVIDER_SEARCH_RESET_RESULTS
});

export const resetProviderDetail = () => ({
  type: PROVIDER_RESET_DETAIL
});

export const getProviderDetails = (criteria: types.ProviderDetailCriteria) => ({
  type: PROVIDER_GET_DETAILS,
  payload: {
    client: 'provider',
    request: {
      url: `${Config.PROVIDER_URL_PROVIDER_DETAILS}/${get(criteria, 'id', '0')}`,
      params: {
        idType: get(criteria, 'idType'),
        getAllProviders: true
      }
    }
  }
});

export const resetComments = () => ({
  type: PROVIDER_RESET_COMMENTS
});

export const getComments = (criteria: Partial<types.ProviderDetailCriteria>) => (
  dispatch: Function,
  getState: Function
) => {
  const provId = get(criteria, 'id') || -1;
  const provIdType = get(criteria, 'idType');

  return dispatch({
    type: PROVIDER_GET_COMMENTS,
    payload: {
      client: 'provider',
      request: {
        url: `${Config.PROVIDER_URL_PROVIDER_GET_COMMENTS}/${provId}/comments`,
        params: {
          idType: provIdType || ID_TYPE_CORPPROV,
          pageSize: Config.PROVIDER_COMMENTS_PAGE_SIZE || 5,
          pageNumber: selectors.commentsPageNumberSelector(getState())
        }
      }
    }
  });
};

export const setHasActiveFilters = (): Thunk => (dispatch, getState) => {
  const activeFilters = selectors.activeFiltersSelector(getState());
  const hasActiveFilters = activeFilters.facets.length + activeFilters.filters.length > 0;

  dispatch({ type: PROVIDER_SET_HAS_ACTIVE_FILTERS, payload: hasActiveFilters });
};

export const setInitialProviderSearchFilter = () => ({
  type: SET_INITIAL_PROVIDER_SEARCH_FILTER
});

export const resetTemporaryProviderSearchFilter = () => ({
  type: RESET_TEMPORARY_PROVIDER_SEARCH_FILTER
});

export const setTemporaryProviderSearchFilter = (filter: Partial<types.ProviderSearchFilters>) => ({
  type: SET_TEMPORARY_PROVIDER_SEARCH_FILTER,
  payload: filter
});

export const setActiveProviderSearchFilter = (
  filter: Partial<types.ProviderSearchFilters>
): Thunk => dispatch => {
  dispatch({ type: SET_ACTIVE_PROVIDER_SEARCH_FILTER, payload: filter });

  dispatch(setHasActiveFilters());
};

export const getHospitals = (): Thunk => (dispatch, getState) => {
  if (selectors.getHospitals(getState()).length <= 0) {
    dispatch({
      type: PROVIDER_GET_HOSPITALS,
      payload: {
        client: 'provider',
        request: {
          method: 'get',
          url: Config.PROVIDER_URL_PROVIDER_GET_HOSPITALS,
          params: {
            isSelectHealthView: profileSelectors.isSelectHealthMemberSelector(getState())
          }
        }
      }
    });
  }
};

export const getClinics = (): Thunk => (dispatch, getState) => {
  if (selectors.getClinics(getState()).length <= 0) {
    dispatch({
      type: PROVIDER_GET_CLINICS,
      payload: {
        client: 'provider',
        request: {
          method: 'get',
          url: Config.PROVIDER_URL_PROVIDER_GET_CLINICS,
          params: {
            isSelectHealthView: profileSelectors.isSelectHealthMemberSelector(getState())
          }
        }
      }
    });
  }
};

export const getLanguages = (): Thunk => (dispatch, getState) => {
  if (selectors.getLanguages(getState()).length <= 0) {
    dispatch({
      type: PROVIDER_GET_LANGUAGES,
      payload: {
        client: 'provider',
        request: {
          method: 'get',
          url: Config.PROVIDER_URL_PROVIDER_GET_LANGUAGES
        }
      }
    });
  }
};

export const resetSearchFilter = () => ({
  type: PROVIDER_RESET_SEARCH_FILTER
});

export const setSortBy = (value: types.OptionType) => ({
  type: PROVIDER_SET_SORT_BY,
  payload: value
});

export const setTextName = (value: string) => ({
  type: PROVIDER_SET_TEXT_NAME,
  payload: value
});

export const setTextLocation = (value: string) => ({
  type: PROVIDER_SET_TEXT_LOCATION,
  payload: value
});

export const setGeoLocation = (value: Coordinate) => ({
  type: PROVIDER_SET_GEO_LOCATION,
  payload: value
});

export const getInsurances = (): Thunk => (dispatch, getState) => {
  if (selectors.insurancesSelector(getState()).length <= 0) {
    dispatch({
      type: PROVIDER_GET_INSURANCES,
      payload: {
        client: 'provider',
        request: {
          method: 'get',
          url: Config.PROVIDER_URL_PROVIDER_GET_INSURANCES,
          params: {
            // Always pass true for both SH and IM Users
            isSelectHealthView: true
          }
        }
      }
    });
  }
};

export const setGender = (value: string) => ({
  type: PROVIDER_SET_SELECTED_GENDER,
  payload: value
});

export const getSpecialties = (): Thunk => (dispatch, getState) => {
  if (selectors.specialtiesSelector(getState()).length <= 0) {
    dispatch({
      type: PROVIDER_GET_SPECIALTIES,
      payload: {
        client: 'azureProviderSearch',
        request: {
          method: 'get',
          url: `${Config.PROVIDER_URL_FACETS}?limit=200`
        }
      }
    });
  }
};

export const setProviderSearchFromRoute = (from: string) => ({
  type: PROVIDER_SET_FROM_ROUTE,
  payload: from
});

export const resetActionTC = () => ({
  type: PROVIDER_RESET_ACTION_TC
});

export const setAcceptedTC = () => ({
  type: PROVIDER_SET_ACCEPTED_TC
});

export const getSuggestions = (name: string): Thunk => (dispatch, getState) => {
  dispatch({
    type: PROVIDER_GET_SUGGESTIONS,
    payload: {
      client: 'azureProviderSearch',
      request: {
        method: 'get',
        url: `${Config.PROVIDER_URL_SUGGEST}?input=${encodeURI(name.trim())}`,
        params: {
          isSelectHealth: profileSelectors.isSelectHealthMemberSelector(getState())
        }
      }
    }
  });
};

export const providerRecentSearch = (
  searchParams: types.ProviderSearchRequest
): Thunk => dispatch => {
  dispatch({
    type: PROVIDER_SEARCH,
    payload: {
      client: 'azureProviderSearch',
      request: {
        method: 'post',
        url: `${Config.PROVIDER_URL_SEARCH}`,
        data: {
          ...searchParams
        }
      }
    }
  });
};
